// import React, { useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import Select from 'react-select';
// import ReactPaginate from 'react-paginate'
// import airfreightratsServices from '../../Services/airfreightratesServices'
// import { ChangeStatus } from '../../Components'
// import Loader from '../../Components/Loader'
// import locationServices from '../../Services/locationServices'
import { MdVisibility, MdEdit } from "react-icons/md"
import { useHistory } from 'react-router'
export const LandFreightRateList = () => {
    const history = useHistory()


    return (

        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between mb-3">
                            <div className="col-xl-3">
                                <Select
                                    placeholder="Search with country..."
                                    // value={countryValue}
                                    // onChange={(e) => onSelectCountry(e)}
                                    options=""
                                />
                            </div>
                            <div className="d-flex justify-content-end mb-3">
                                <div>
                                    <input type="file" id="upload" hidden />
                                    <label for="upload" className="btn btn-primary waves-effect waves-light mx-1 my-0">Upload File</label>
                                </div>
                                <button className="btn btn-primary w-sm waves-effect waves-light mx-3"
                                // onClick={() => history.push('/sea-air-freight-rate')}
                                > <Link className="text-white" to="/add-land-freight-rate" > Add LandFreightRate</Link>
                                </button>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-centered table-nowrap mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>S no.</th>
                                        {/* <th>Origin city</th>
                                        <th>Destination city</th>
                                        <th>Origin country</th> */}
                                        <th>Destination country</th>
                                        <th>Door delivery tt</th>
                                        <th>Port delivery tt</th>
                                        <th>Fuel</th>
                                        <th>Normal amount</th>
                                        <th>Minimum amount</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    <tr>
                                        <td className="text-body fw-bold">01</td>
                                        {/* <td>Indore</td>
                                        <td>New York</td>
                                        <td>India</td> */}
                                        <td>USA</td>
                                        <td>15.30</td>
                                        <td>17</td>
                                        <td>200</td>
                                        <td>659 AED</td>
                                        <td>659 AED</td>
                                        <td>
                                            <span
                                                className="badge rounded-pill bg-success font-size-12 pointer"

                                            >Active</span>
                                        </td>
                                        <td>
                                            {/* Button trigger modal */}
                                            <MdEdit
                                                className="pointer"
                                                // onClick={() => history.push('/edit-air-origin-courier-charge?id=' + item._id, item)}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                            <MdVisibility
                                                className="pointer"
                                                onClick={() => history.push('/land-freight-rate-details')}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-body fw-bold">01</td>
                                        {/* <td>Indore</td>
                                        <td>New York</td>
                                        <td>India</td> */}
                                        <td>USA</td>
                                        <td>15.30</td>
                                        <td>17</td>
                                        <td>200</td>
                                        <td>659 AED</td>
                                        <td>659 AED</td>
                                        <td>
                                            <span
                                                className="badge rounded-pill bg-success font-size-12 pointer"

                                            >Active</span>
                                        </td>
                                        <td>
                                            {/* Button trigger modal */}
                                            <MdEdit
                                                className="pointer"
                                                // onClick={() => history.push('/edit-air-origin-courier-charge?id=' + item._id, item)}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                            <MdVisibility
                                                className="pointer"
                                                onClick={() => history.push('/land-freight-rate-details')}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                        </td>
                                    </tr>


                                    <tr>
                                        <td className="text-body fw-bold">01</td>
                                        {/* <td>Indore</td>
                                        <td>New York</td>
                                        <td>India</td> */}
                                        <td>USA</td>
                                        <td>15.30</td>
                                        <td>17</td>
                                        <td>200</td>
                                        <td>659 AED</td>
                                        <td>659 AED</td>
                                        <td>
                                            <span
                                                className="badge rounded-pill bg-success font-size-12 pointer"

                                            >Active</span>
                                        </td>
                                        <td>
                                            {/* Button trigger modal */}
                                            <MdEdit
                                                className="pointer"
                                                // onClick={() => history.push('/edit-air-origin-courier-charge?id=' + item._id, item)}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                            <MdVisibility
                                                className="pointer"
                                                onClick={() => history.push('/land-freight-rate-details')}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                        </td>
                                    </tr>


                                    <tr>
                                        <td className="text-body fw-bold">01</td>
                                        {/* <td>Indore</td>
                                        <td>New York</td>
                                        <td>India</td> */}
                                        <td>USA</td>
                                        <td>15.30</td>
                                        <td>17</td>
                                        <td>200</td>
                                        <td>659 AED</td>
                                        <td>659 AED</td>
                                        <td>
                                            <span
                                                className="badge rounded-pill bg-success font-size-12 pointer"

                                            >Active</span>
                                        </td>
                                        <td>
                                            {/* Button trigger modal */}
                                            <MdEdit
                                                className="pointer"
                                                // onClick={() => history.push('/edit-air-origin-courier-charge?id=' + item._id, item)}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                            <MdVisibility
                                                className="pointer"
                                                onClick={() => history.push('/land-freight-rate-details')}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                            {/* {airFreightRateList.length <= 0 && !loader &&
                                <div className="text-center w-100 bg-warning my-5">
                                    <h6 className="py-2"> list not available </h6>
                                </div>
                            } */}
                        </div>
                    </div>
                    {/* {airFreightRateList.length > 0 && pagination.totalRecord > pagination.limit &&
                        <ReactPaginate
                            previousLabel={<img src="assets/images/prev.svg" height={15} />}
                            forcePage={currentPage - 1}
                            nextLabel={<img src="assets/images/next.svg" height={15} />}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={(e) => onPageChangeEvent(e)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    } */}
                    {/* <Loader isShow={loader} /> */}
                </div>
                {/* {Boolean(isModalOpen) &&
                    <ChangeStatus
                        isOpen={Boolean(isModalOpen)}
                        title='Update Status'
                        message={`Are you sure want to ${isModalOpen.airfreight_status === 'ACTIVE' ? 'Inactive' : 'Active'} status ?`}
                        onSubmitEvent={() => onModalSubmit()}
                        handleClose={() => setIsModalOpen(false)}
                    />
                } */}
            </div>
        </div>
    )
}
